"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monguzzo": {
    "c2cdf364": [{
      "hkey": "6f33f36e",
      "slug": "bassetto-fornace",
      "name": "Bassetto-Fornace",
      "primary": true,
      "skipSearch": false
    }],
    "bassetto-e-fornace": [{
      "hkey": "6f33f36e",
      "slug": "bassetto-fornace",
      "name": "Bassetto-Fornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9e016284": [{
      "hkey": "c1a145c6",
      "slug": "bindella",
      "name": "Bindella",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-bindella": [{
      "hkey": "c1a145c6",
      "slug": "bindella",
      "name": "Bindella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f849039d": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-enrichetta": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa041de5": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-nuova": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0bfba47": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-san-biagio": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d421a905": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-solferino": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af04eb2d": [{
      "hkey": "5c7807be",
      "slug": "centro-nobile",
      "name": "Centro-Nobile",
      "primary": true,
      "skipSearch": false
    }],
    "nobile": [{
      "hkey": "5c7807be",
      "slug": "centro-nobile",
      "name": "Centro-Nobile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d13766cf": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-castello": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d9213e91": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "skipSearch": false
    }],
    "sceria": [{
      "hkey": "b8058dbd",
      "slug": "monguzzo",
      "name": "Monguzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;